import { TripTypeFilter } from "@features/Pages/SalesAdminPage/Types/TripTypeFilter";
import type { KeyValueItem } from "@shared/Components/Dropdown/Dropdown.types";

export function getTripTypeOptions(tripTypes: TripTypeFilter[]): KeyValueItem[] {
  return tripTypes.map((tripType) => ({
    key: getTripTypeLabel(tripType),
    value: tripType.toString(),
  }));
}

export function getTripTypeLabel(tripType: TripTypeFilter): string {
  if (tripType === TripTypeFilter.Business) {
    return "Företag";
  }

  if (tripType === TripTypeFilter.Customer) {
    return "Privat";
  }

  return "Alla";
}

export function parseTripType(value: string | null): TripTypeFilter | null {
  if (value === null) {
    return null;
  }

  const parsedValue = Number(value);

  if (parsedValue === TripTypeFilter.Business) {
    return TripTypeFilter.Business;
  }

  if (parsedValue === TripTypeFilter.Customer) {
    return TripTypeFilter.Customer;
  }

  if (parsedValue === TripTypeFilter.None) {
    return TripTypeFilter.None;
  }

  return null;
}
